import { Component, OnInit, Input } from '@angular/core';
import { GenericResponse } from 'src/app/data/repository/generic-response';
import { UserApiService } from 'src/app/data/repository/user-repository/user-api.service';

@Component({
  selector: 'app-edit-gender',
  templateUrl: './edit-gender.component.html',
  styleUrls: ['./edit-gender.component.scss'],
})
export class EditGenderComponent implements OnInit {
  @Input() gender: string;

  constructor(private userApiService: UserApiService) {}

  ngOnInit() {}

  save(): Promise<GenericResponse> {
    // console.log('saved', this.gender);
    return this.userApiService.editUser(null, this.gender, null, null, null);
  }

  genderSelect(gender: string) {
    this.gender = gender;
  }
}
